<template>
  <div class="item" :data-nutrient="item.key">
    <div class="side nut">
      <app-sel
        styling="inline"
        key-name="label"
        v-if="isSeveralTyped"
        v-model="selected"
        :items="item.types"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="nut"
            v-for="nut in items"
          >
            {{ nut.label }}
          </app-sel-opt>
        </template>
      </app-sel>
      <div class="as-default" v-else>
        {{ item.label }}
      </div>
    </div>
    <div class="side unit">
      <!-- <app-sel
        styling="inline"
        v-model="unit"
        key-name="label"
        :items="Object.keys(nutrient.units).map(item => {return {label: item}})"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="unit"
            v-for="unit in items"
          >
            {{ $ml.get(unit.label) }}
          </app-sel-opt>
        </template>
      </app-sel> -->
      <p>
        {{ isSeveralTyped ? '%' : 'ppm' }}
      </p>
    </div>
    <div class="side value">
      <app-number-input
        :placeholder="$ml.get(`Enter value`)"
        :value="convert()"
        @input="onInput"
        min-width="100px"
        :min="min"
        :max="isSeveralTyped ? 100 : 9999999999"
      />

      <!-- <app-number-input
        v-else
        :placeholder="$ml.get(`Enter value`)"
        :value="value"
        @input="$emit('input', $event)"
      /> -->
    </div>
    <div
      class="side interpretation"
      :class="{
        'adequate': value && warningLevel === 'Adequate',
        'high': value && warningLevel === 'High',
        'low': value && warningLevel === 'Low',
        'excessive': value && warningLevel === 'Excessive',
        'none': !value,
      }"
    >
      <template v-if="!value">
        {{ $ml.get(`None`) }}
      </template>
      <template v-else>
        {{ $ml.get(warningLevel) }}
      </template>
    </div>
  </div>
</template>

<script>
import { NutrientConverter } from '@/mixins/nutrient-converter.mixin';
import { UnitConverter } from '@/mixins/unit-converter.mixin';

export default {
  mixins: [ NutrientConverter, UnitConverter ],
  props: {
    item: {

    },
    value: {

    },
    min: {
      type: Number,
      default: 0
    }
  },
  methods: {

    onInput(value) {
      if (this.isSeveralTyped) {
        value = this.unconvertNutrientType(this.item.key, this.selected, value);
      }
      value = this.toPpm(this.item.key, this.unit, value);
      // value = Math.max(0, parseInt(value) || 0)
      this.$emit('input', value);
    },

    // unconverting view
    convert() {
      let val = this.value;
      // console.log(val)
      // val = Math.max(0, parseInt(val) || 0)
      
      if (this.isSeveralTyped) {
        val = this.convertNutrientType(this.item.key, this.selected, this.value);
      }
      val = this.toUnit(this.item.key, this.unit, val);
      return val ? val.toFixedGentle(2) : null;
    },
  },
  data() {
    return {
      selected: null,
      unit: 'ppm',
    }
  },
  created() {
    if(this.isSeveralTyped) {
      this.selected = this.item.types[0].label;
    }
    // console.log(this.item);
  },
  computed: {
    isSeveralTyped() {
      return this.item.types ? true : false;
    },
    warningLevel() {
      const lvl = this.$store.getters['tests/tissue/getWarningLevel'](this.value, this.item.key);

      // TODO: make translations instead of this
      return this.$store.getters['tests/tissue/renderWarningLevel'](lvl);
    },
    // unit: {
    //   get(){
    //     return this.isSeveralTyped ? '%' : 'ppm';
    //   },
    //   set(val){
    //    return val;
    //   }
    // },
    nutrient() {
      return this.$store.getters['nutrients/getNutrientByKey'](this.item.key);
    },
  },
}
</script>

<style lang="scss">

</style>
